import React from "react";
import ReceiverMessageCloud from "./ReceiverMessageCloud";
import SenderMessageCloud from "./SenderMessageCloud";
import {
  pinUnPinMessage,
  flagUnflagMessage,
  deleteMessage,
} from "../../ContextMenuHelper";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const Message = (props) => {
  const [message, setMessage] = useState(props);
  const [open, setDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    if (
      props.message !== message.message ||
      props.attachmentId !== message.attachmentId
    ) {
      setMessage((prev) => {
        return {
          ...prev,
          message: props.message,
          accessType: props.accessType,
          createdByName: props.createdByName,
          hasAttachment: props.hasAttachment,
          attachmentName: props.attachmentName,
          attachmentSize: props.attachmentSize,
          attachmentId: props.attachmentId,
          isEdited: false,
          isDeleted: false,
          createdOn: props.createdOn,
          isPinned: props.isPinned,
          isFlagged: props.isFlagged,
          messageId: props.messageId,
        };
      });
    }
  }, [
    props.messageId,
    props.message,
    props.isPinned,
    props.isFlagged,
    props.accessType,
  ]);

  const onContextMenuSet = (option) => {
    if (option === "Edit") {
      props.onMessageUpdate(props);
    } else if (option === "Copy") {
      navigator.clipboard.writeText(props.message);
    } else if (option === "Pin") {
      pinUnPinMessage(message.messageId, !message.isPinned);
      props.onPinOrFlagChanges(
        {
          ...message,
          isPinned: !message.isPinned,
          isFlagged: message.isFlagged,
          isEdited: true,
        },
        true
      );
      setMessage((prev) => {
        return { ...prev, isPinned: !prev.isPinned };
      });
    } else if (option === "Flag") {
      flagUnflagMessage(message.messageId, !message.isFlagged);
      props.onPinOrFlagChanges({
        ...message,
        isPinned: message.isPinned,
        isFlagged: !message.isFlagged,
        isEdited: true,
      });
      setMessage((prev) => {
        return { ...prev, isFlagged: !prev.isFlagged };
      });
    } else if (option === "Delete") {
      setIsDeleting(false);
      setDialogOpen(true);

    }
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    const resp = await deleteMessage(props.messageId);
    if (!resp.data) console.error(resp);
    setDialogOpen(false);
    setIsDeleting(false);
    props.onDeleteMessage(props);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
 
  return (
    <>
    <Dialog open={open} className="delete-message-dialog" onClose={handleDialogClose}>
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        <DialogActions className="w-100 d-flex">
          <Button
            variant="outlined"
            onClick={handleDialogClose}
            style={{ padding: "12px" }}
          >
            Cancel
          </Button>
          {isDeleting ? (
               <Box 
                style={{display: "flex", marginLeft: "auto", padding: "5px" }}
              >
                <CircularProgress size={28} />
              </Box>
          ) : (
            <Button
              variant="contained"
              onClick={confirmDelete}
              style={{ marginLeft: "auto", padding: "12px" }}
            >
              Yes, delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {props.createdByName === "You" ? (
        <SenderMessageCloud style={{ whiteSpace: 'pre-wrap' }}
          {...message}
          onContextMenuSet={onContextMenuSet}
          contextOptions={props.options}
        />
      ) : (
        <ReceiverMessageCloud style={{ whiteSpace: 'pre-wrap' }}
          {...message}
          onContextMenuSet={onContextMenuSet}
          contextOptions={props.options}
        />
      )}
    </>
  );
};

export default Message;
